import type { FC, PropsWithChildren, ReactNode } from 'react';

import { branch, nest, renderComponent } from 'recompact';

import StandardPage from 'src/app/components/Elements/Page/Standard';
import Spinner from 'src/app/components/Elements/Spinner';

const defaultLoader = (
  <div>
    <Spinner centered />
  </div>
);

export const withStandardPageAndLoading = (title?: any, customLoader?: ReactNode) => (BaseComponent: FC) => {
  return nest(
    ({ children }: PropsWithChildren<Record<never, never>>) => <StandardPage title={title}>{children}</StandardPage>,
    branch(
      (props: { isLoading: boolean }) => props.isLoading,
      renderComponent(() => (customLoader ? customLoader : defaultLoader))
    )(BaseComponent)
  );
};
